var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm.isMobile
        ? _c("img", {
            staticClass: "sidebar-logo",
            attrs: { src: require("@/assets/ap-logo.png") },
          })
        : _vm._e(),
      !_vm.isMobile
        ? _c("breadcrumb", {
            staticClass: "breadcrumb-container",
            attrs: { id: "breadcrumb-container" },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          !_vm.isMobile
            ? [
                _vm.showMerchantRtpSetter
                  ? _c(
                      "div",
                      { staticClass: "merchant-rtp" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("商户RTP"),
                        ]),
                        !_vm.merchantRtpEditing
                          ? [
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.merchantRtpLoading
                                      ? "--"
                                      : _vm.merchantRtp
                                  )
                                ),
                              ]),
                              _c("el-button", {
                                attrs: {
                                  icon: "el-icon-edit",
                                  type: "text",
                                  disabled:
                                    _vm.merchantRtpLoading ||
                                    _vm.merchantRtpSubmitting,
                                },
                                on: { click: _vm.startEditMerchantRtp },
                              }),
                            ]
                          : [
                              _c("el-input-number", {
                                staticClass: "input",
                                staticStyle: { width: "90px" },
                                attrs: {
                                  size: "mini",
                                  min: 0,
                                  max: 97,
                                  controls: true,
                                  "controls-position": "right",
                                },
                                model: {
                                  value: _vm.merchantRtpDraft,
                                  callback: function ($$v) {
                                    _vm.merchantRtpDraft = $$v
                                  },
                                  expression: "merchantRtpDraft",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "button-group" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        loading: _vm.merchantRtpSubmitting,
                                        disabled: _vm.merchantRtpSubmitting,
                                      },
                                      on: { click: _vm.submitMerchantRtp },
                                    },
                                    [_vm._v("保存 ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "small",
                                        disabled: _vm.merchantRtpSubmitting,
                                      },
                                      on: { click: _vm.cancelEditMerchantRtp },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _c("NavbarTimezoneClocks"),
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" },
                }),
              ]
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c("svg-icon", {
                    staticClass: "user-icon mr-2",
                    attrs: { "icon-class": "user-circle" },
                  }),
                  !_vm.isMobile
                    ? _c(
                        "div",
                        { staticClass: "user-name mr-1" },
                        [
                          _vm._v(" " + _vm._s(_vm.name) + " "),
                          _c("el-tag", { attrs: { size: "mini" } }, [
                            _vm._v(_vm._s(_vm.roleName)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("i", { staticClass: "el-icon-caret-bottom" }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _vm.isMobile
                    ? _c("el-dropdown-item", [
                        _c(
                          "div",
                          { staticClass: "user-name mr-1" },
                          [
                            _vm._v(" " + _vm._s(_vm.name) + " "),
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(_vm._s(_vm.roleName)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出登录"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }